<template>
  <div
    :style="jobCounterElStyles"
    class="job-counter"
    v-if="general.jobCounter.showJobCounter"
  >
    {{ jobCountString ? jobCountString : general.jobCounter.jobsText }}
  </div>
</template>

<script>
export default {
  name: "CoverUIJobCounter",
  props: {
    general: {
      type: Object,
      default() {
        return {};
      },
    },
    jobCounter: {
      type: Object,
      default() {
        return {};
      },
    },
    jobCountString: {
      type: String,
      default: "",
    },
  },
  computed: {
    jobCounterElStyles() {
      const { isTextInCaps, textColor } = this.jobCounter;

      const styles = {
        textTransform: isTextInCaps ? "uppercase" : "initial",
        color: textColor.value,
      };
      return styles;
    },
  },
};
</script>

<style lang="scss" scoped>
.job-counter {
  font-style: normal;

  @include font-family("body");
  @include scale-fonts("body");
}
</style>
